/**
 * Regular expression that matches the below URL patterns
 *  - https://www.example.com
 *  - https:/*.example.com
 *  - https://example.com/*
 *  - https://*.example.com/*
 */
export const REGEX_HTPPS_URL_WILDCARD =
  /^https:\/\/(((www)|\*)\.)?([-a-zA-Z0-9@:%._+~#=]{1,256})\.([\w-]+\/?)+\*?$/

export const REGEX_HTPPS_URL_WILDCARD_QUERY =
  /^(https?:\/\/)(\*\.?|www\.)?(localhost|(\d{1,3}\.){3}\d{1,3}|[-a-zA-Z0-9@:%._+~#=]{1,256}(\.[a-zA-Z]{2,})+)(:\d{1,5})?(\/[^\s?#]*)?(\?([a-zA-Z0-9._~%-]+=[^&#\s]*)(?:&[a-zA-Z0-9._~%-]+=[^&#\s]*)*)?(#[^\s#]+)?$/

export const REGEX_URL_WILDCARD =
  /^((ftp|http|https):\/\/)?(www.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/

export const REGEX_URL_WILDCARD_ASTERISK =
  /^(?:(ftp|http|https):\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b(?:[-a-zA-Z0-9@:%_+.~#?&//=]*\*)?$/

export const REGEX_HTPPS_URL =
  /^https:\/\/(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+(?:\/[\w.-]*)*(?:\?[a-zA-Z0-9-._~,!%&'()*;=:@+/]*)?(?:#[\w-]*)?$/

export const REGEX_LOCAL_URL_WILDCARD = /^\/.*$/

export const REGEX_HEX_COLOR = /^#([0-9a-fA-F]{3}){1,2}$/

export const PHONE_NUMBER_REGEX =
  /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/

export const NEWLINE_PATTERN = /(?:\r\n|\r|\n)/g
export const URL_PATTERN = /(https?:\/\/[^\s<]+)(?=<br>|\.\s|$)/g
